const SafePayment = () => {
    return (
        <section className="icon_wepper same_space_div">
            <div className="container">
                <div className="row">
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6">
                        <div className="shoping_wepper" data-aos="fade-down" data-aos-duration="3000">
                            <img src="images/shipping.png" alt="" />
                            <p> Free Shipping over Rs.999 </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6">
                        <div className="shoping_wepper" data-aos="fade-up" data-aos-duration="3000">
                            <img src="images/safe.png" alt="" />
                            <p> Safe Payment </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6">
                        <div className="shoping_wepper" data-aos="fade-left" data-aos-duration="3000">
                            <img src="images/deliver.png" alt="" />
                            <p> On Time Delivery </p>
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-3 col-sm-6 col-6">
                        <div className="shoping_wepper" data-aos="fade-right" data-aos-duration="3000">
                            <img src="images/madein.png" alt="" />
                            <p> Made in INDIA </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default SafePayment;